import React, { useState } from 'react';
import { getLandingIMessageHref, LANDING_REVIEWS_CTA_TEXT } from './LandingConstants';
import socialProofDesktop from '../../../images/ExperiencePage/MrSea_TripAdvisorDesktop.png';
import socialProofMobile from '../../../images/ExperiencePage/MrSea_TripAdvisorMobile.png';

const LandingSocialProofImageSection = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <section className="landing-social-proof-image">
      <div className="landing-social-proof-image__inner">
        <h2 className="landing-social-proof-image__title">What people are saying</h2>
        <div className={`landing-social-proof-image__media landing-skeleton-image-wrap${imageLoaded ? ' landing-skeleton-image-wrap--loaded' : ''}`}>
          <div className="landing-skeleton" aria-hidden="true" />
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={socialProofMobile}
            />
            <img
              src={socialProofDesktop}
              alt="What people are saying about Mr. Sea Miami - TripAdvisor reviews"
              className="landing-social-proof-image__img"
              width="1200"
              height="630"
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
            />
          </picture>
        </div>
        <a
          href={getLandingIMessageHref()}
          className="landing-hero__cta"
          rel="noopener noreferrer"
        >
          {LANDING_REVIEWS_CTA_TEXT}
        </a>
      </div>
    </section>
  );
};

export default LandingSocialProofImageSection;
